import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-common-popup',
  templateUrl: './common-popup.component.html',
  styleUrls: ['./common-popup.component.scss']
})
export class CommonPopupComponent {

  @Input() title: string;
  @Input() description: string;
  @Input() placeholder: string;
  @Output() comments = new EventEmitter<string>();

  commentFC = new FormControl();

  constructor(public dialogRef: MatDialogRef<CommonPopupComponent>) {
  }


  onCommentChange() {
    const comment = this.commentFC.value;
    this.comments.emit(comment);
  }

}
